// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"65cd5471","711":"41edc70e"}[chunkId] + ".chunk.css";
};